import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  type InputSignal,
  type Signal,
} from '@angular/core';
import { UiNoteTone } from '../../types/ui-note-tone.type';

@Component({
  selector: 'ui-note',
  imports: [],
  templateUrl: './ui-note.component.html',
  styleUrl: './ui-note.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UiNoteComponent {
  public readonly title: InputSignal<string | null> = input<string | null>(null);
  public readonly tone: InputSignal<UiNoteTone> = input<UiNoteTone>('info');

  protected readonly role: Signal<'status' | 'alert'> = computed((): 'status' | 'alert' =>
    this.tone() === 'danger' ? 'alert' : 'status',
  );
  protected readonly isSuccess: Signal<boolean> = computed((): boolean => this.tone() === 'success');
  protected readonly isWarning: Signal<boolean> = computed((): boolean => this.tone() === 'warning');
  protected readonly isDanger: Signal<boolean> = computed((): boolean => this.tone() === 'danger');
}
